import api from '../axiosConfig';

const API_URL = '/api/stock_issue';

export const fetchStockIssues = (params = {}) => api.get(API_URL, { params });
export const fetchStockIssueById = (id) => api.get(`${API_URL}/${id}`);
export const createStockIssue = (data) => api.post(API_URL, data);
export const markStockIssueReceived = (id, received_by) => api.put(`${API_URL}/${id}/receive`, { received_by });
export const deleteStockIssue = (id) => api.delete(`${API_URL}/${id}`);

// New methods for filtering
export const fetchStockIssuesByEmployee = (emp_code, status = null, fromDate = null, toDate = null) => {
  const params = {};
  if (status) params.status = status;
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  return api.get(`${API_URL}/employee/${emp_code}`, { params });
};

export const fetchStockIssuesByBatch = (batch_no, status = null, fromDate = null, toDate = null) => {
  const params = {};
  if (status) params.status = status;
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  return api.get(`${API_URL}/batch/${batch_no}`, { params });
};

export const fetchUniqueEmployees = (status = null) => {
  const params = status ? { status } : {};
  return api.get(`${API_URL}/employees`, { params });
};

export const fetchUniqueBatches = (status = null) => {
  const params = status ? { status } : {};
  return api.get(`${API_URL}/batches`, { params });
};

export const fetchRawGoldIssuedReport = (filters = {}) =>
  api.get(`${API_URL}/report/raw-gold-issued`, { params: filters });

export const fetchStoneIssuedReport = (filters = {}) =>
  api.get(`${API_URL}/report/stone-issued`, { params: filters });

export const fetchStockReceivedReport = (filters = {}) =>
  api.get(`${API_URL}/report/stock-received`, { params: filters });

export const fetchStockIssuesForReceive = (status = 'issued', fromDate = null, toDate = null) => {
  const params = {};
  if (status) params.status = status;
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  console.log('API: fetchStockIssuesForReceive called with params:', params);
  console.log('API: Making request to:', `${API_URL}/receive-pending`);
  return api.get(`${API_URL}/receive-pending`, { params });
}; 